import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
    doc,
    getDoc,
    updateDoc
} from "firebase/firestore";

import { db } from "../../firebase/firebase";

import {
    CLOUDINARY_URL,
    UPLOAD_PRESET
} from "../../services/cloudinary";

import "../../assets/css/admin/editGalleryCategory.css";

function EditGalleryCategory() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [title, setTitle] = useState("");

    const [image, setImage] = useState(null);

    const [preview, setPreview] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});
useEffect(() => {

    const fetchCategory = async () => {

        try {

            const docRef = doc(db, "gallery_categories", id);

            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {

                const data = docSnap.data();

                setTitle(data.title);
                setPreview(data.coverImage);

            } else {

                setPopup({
                    show: true,
                    type: "error",
                    message: "Gallery Category Not Found"
                });

                setTimeout(() => {

                    navigate("/admin/gallery-categories");

                }, 2000);
            }

        } catch (error) {

            console.log(error);

        }

    };

    fetchCategory();

}, [id, navigate]);
    const handleImage = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setImage(file);

        setPreview(URL.createObjectURL(file));

    };

    const uploadImage = async () => {

        const formData = new FormData();

        formData.append("file", image);

        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await fetch(CLOUDINARY_URL, {

            method: "POST",

            body: formData

        });

        const data = await response.json();

        if (!response.ok) {

            throw new Error(data.error?.message);

        }

        return data.secure_url;

    };

    const updateCategory = async (e) => {

        e.preventDefault();

        if (!title.trim()) {

           setError("Please enter category name");

return;

            

        }

        try {

            setLoading(true);

            let imageUrl = preview;

            if (image) {

                imageUrl = await uploadImage();

            }

            await updateDoc(

                doc(db, "gallery_categories", id),

                {

                    title,

                    coverImage: imageUrl

                }

            );

            setPopup({
    show: true,
    type: "success",
    message: "Gallery Category Updated Successfully"
});

setTimeout(() => {

    navigate("/admin/gallery-categories");

}, 2000);

        }

        catch (error) {

            console.log(error);

            setPopup({
    show: true,
    type: "error",
    message: "Update Failed"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };

    return (
   <>{popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}
        <div className="add-gallery-category-page">

            <div className="add-gallery-card">

                <h1>Edit Gallery Card</h1>

                <form onSubmit={updateCategory}>

                    <div className="form-group">

                        <label>Gallery Category</label>

                        <input
                            type="text"
                            value={title}
                            onChange={(e) => {

    setTitle(e.target.value);

    setError("");

}}
                        />

                        {error && (

    <p className="validation-error">

        {error}

    </p>

)}

                    </div>

                    <div className="form-group">

                        <label>Change Cover Image</label>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImage}
                        />

                    </div>

                    {preview && (

                        <div className="preview-container">

                            <img
                                src={preview}
                                alt="Preview"
                                className="preview-image"
                            />

                        </div>

                    )}

                    <button
                        className="save-btn"
                        disabled={loading}
                    >

                        {

                            loading

                                ? "Updating..."

                                : "Update Gallery"

                        }

                    </button>

                </form>

            </div>

        </div>
       </>
    );

}

export default EditGalleryCategory;